import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { PerfilService } from 'src/app/services/perfil.service';
import { PerfilNormalizado } from '../../enums/perfil-normalizado.enum';
import { ParametrosDataService } from 'src/app/services/parametros-data.service';
import { ParametrosKey } from '../../enums/parametros.enum';

@Injectable({ providedIn: 'root' })
export class CadastroGuard implements CanActivate {
    constructor(
        private router: Router,
        private perfilService: PerfilService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentPerfis = this.perfilService.currentPerfisValue;
        if (currentPerfis) {
            if (currentPerfis.some(x => x.nomeNormalizado === PerfilNormalizado.Cadastro) || currentPerfis.some(x => x.nomeNormalizado === PerfilNormalizado.Responsavel)) {
                return true;
            }
        }

        this.router.navigate(['accessdenied']);
        return false;
    }
}
